import { getI18n } from 'react-i18next'
import { IPerson, IPersonRole } from '../interfaces/persons/IPerson'
import { IRole } from '../interfaces/projects/IProjects'

export const getRole = (person: IPerson) => {
  if (person.department && !person.titleFi && !person.titleEng) return person.department
  if (person.department && (getI18n().language === 'en' ? person.titleEng : person.titleFi))
    return `${person.department} - ${getI18n().language === 'en' ? person.titleEng : person.titleFi}`
  if (!person.department && (getI18n().language === 'en' ? person.titleEng : person.titleFi))
    return getI18n().language === 'en' ? person.titleEng : person.titleFi
  return ''
}

/**
 * Return localized role name with graceful fallback to legacy roleName.
 */
export const getLocalizedRoleName = (role: IRole | IPersonRole) => {
  const lng = getI18n().language
  // Prefer structured multilingual names
  const nameEng = (role as any).roleNameEng as string | undefined
  const nameFi = (role as any).roleNameFi as string | undefined
  if (lng === 'en') {
    if (nameEng && nameEng.trim().length) return nameEng
    if (nameFi && nameFi.trim().length) return nameFi
  } else {
    if (nameFi && nameFi.trim().length) return nameFi
    if (nameEng && nameEng.trim().length) return nameEng
  }
  // Legacy single field
  const legacy = (role as any).roleName as string | undefined
  return legacy || ''
}
